import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Route } from 'react-router';
import { ConnectedRouter } from 'react-router-redux';
import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.css';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import TagManager from 'react-gtm-module';

import App from './components/app/app';
import ErrorBoundary from './airbrake';
import store, { history } from './store';
import {unregister} from './registerServiceWorker';

import './assets/style/index.css';
import './assets/style/bootstrap-theme.css';
import './assets/style/user-frontend/index.css';
import './assets/style/user-frontend/bootstrap-theme.css';
import withTracker from './withTracker';
import {GOOGLE_TAG_MANAGER_API_KEY} from './data/googleTagManager';

const tagManagerArgs = {
  gtmId: GOOGLE_TAG_MANAGER_API_KEY
};

TagManager.initialize(tagManagerArgs);

render(
  <ErrorBoundary>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Route component={withTracker(App, { /* additional attributes */ })} />
      </ConnectedRouter>
    </Provider>
  </ErrorBoundary>,
  document.getElementById('root')
);

unregister();



// WEBPACK FOOTER //
// ./src/index.js